import CowFaceSvg from 'assets/svgs/cow-face.svg';
import { ThemeUICSSObject } from 'theme-ui';

import BaseIcon from './BaseIcon';

const RefrigeratedDairyIcon = ({
  style,
  testId,
  color = '#615E54',
  ...rest
}: {
  color?: string;
  count?: number;
  style?: ThemeUICSSObject;
  testId?: string;
}): JSX.Element | null => {
  return (
    <BaseIcon
      labelText="Refrigerated Dairy"
      {...rest}
      style={{ ...style, color }}
      testId={`refrigerated-dairy-icon-${testId}`}
    >
      <CowFaceSvg />
    </BaseIcon>
  );
};

export default RefrigeratedDairyIcon;
